import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { toast } from 'react-toastify';

import Header from '../Header';
import LeftSideBar from '../LeftSideBar';
import MainContent from '../MainContent';
import ConfirmModal from '../ConfirmModal';

import Loader from '../Loader';
import useWindowSize from '@hooks/useWindowSize';

import stores from '@stores';

interface Props {
  children: React.ReactNode
}

const MIN_WIDTH = 1099;

const MainLayout = ({ children }: Props) => {
  const [windowWidth] = useWindowSize();

  const {
    layoutStore: { confirmModal },
    sessionStore: { currentUser, errors },
    projectsStore: { errors: projectsErorrs },
    dictionariesStore: { errors: dictionariesError },
    studentsStore: { errors: studentsErrors }
  } = stores;

  useEffect(() => {
    if (errors || projectsErorrs || dictionariesError || studentsErrors) {
      toast.error(errors?.message);
    }
  }, [errors, projectsErorrs, dictionariesError, studentsErrors]);

  return (
    <>
      <Header />

      {windowWidth >= MIN_WIDTH ?
        <>
          <LeftSideBar />
          <MainContent children={!currentUser ? <Loader filled={false} /> : children} />
        </>
        : (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            minHeight: '100vh',
            textAlign: 'center'
          }}>
            <h2
              style={{
                margin: '0 0 10px',
                lineHeight: '1.2',
                fontSize: '2rem'
              }}
            >Mobile or laptop devices are not supported</h2>
            <p
              style={{
                margin: '0 0 10px',
                fontSize: '1rem',
                color: '#778097'
              }}
            >Currently we do not support mobile devices. Please use desktop instead.</p>
            <p style={{
              margin: '0 0 10px',
              fontSize: '1rem',
              color: '#778097'
            }}>Sorry for inconvenience</p>
          </div>
        )}

      {confirmModal && <ConfirmModal />}
    </>
  );
};

export default observer(MainLayout);
